import { Box, Button } from '@mui/material'
import { Navbar } from '../../components/Navbar'
import { Footer } from '../../components/Footer'
import { PageContainer } from '../../components/styled/PageContainer'
import { TermsCondition } from './TermsCondition'
import { Link } from 'react-router-dom'
import { RedeemCounter } from '../../components/RedeemCounter'
import { Description } from './Description'

export const GetMoreForLess = () => {
  return (
    <Box>
      <Navbar />
      <Box display='flex' justifyContent='center'>
        <img src={'client-static/images/Banner2026.png'} width='100%' />
      </Box>
      <PageContainer>
        {/* <Description /> */}
        <TermsCondition />
        {/* <RedeemCounter /> */}
        <Box display='flex' justifyContent='center' alignItems='center' mb={10}>
          <Button
            color='primary'
            variant='contained'
            sx={{ minWidth: '250px' }}
            component={Link}
            to='/register'
          >
            Join the promotion
          </Button>
          {/* <Box
            display='flex'
            justifyContent='space-between'
            sx={{
              minWidth: { xs: '200px', sm: '600px' },
              flexDirection: { xs: 'column', sm: 'row' },
              minHeight: { xs: 90, sm: 25 }
            }}
          >
            <Button
              color='primary'
              variant='contained'
              sx={{ minWidth: '250px' }}
              component={Link}
              to='/register'
            >
              Join the promotion
            </Button>
            <Button
              color='primary'
              variant='contained'
              sx={{ minWidth: '250px' }}
              component={Link}
              to='/mobilauthorizeddealers'
            >
              Where to buy
            </Button>
          </Box> */}
        </Box>
      </PageContainer>
      <Footer />
    </Box>
  )
}
